// Copyright (c) 2021 Sendanor. All rights reserved.

import { SendanorIcon } from "../../../core/types/SendanorIcon";
import { ReactComponent as ShoppingCartIcon } from "./noun_Shopping_Cart_757319.svg";
import { ReactComponent as TrashIcon } from "./noun_Trash_3523712.svg";
import { ReactComponent as SignInIcon } from "./noun_signin_1920871.svg";
import { ReactComponent as SignOutIcon } from "./noun_signout_1920898.svg";
import { ReactComponent as MenuIcon } from "./noun_menu_3661996.svg";
import { ReactComponent as DomainsIcon } from "./domains.svg";
import { ReactComponent as VirtualserversIcon } from "./virtualservers.svg";
import { ReactComponent as ShellsIcon } from "./shells.svg";
import { ReactComponent as DatabasesIcon } from "./databases.svg";
import { ReactComponent as WebhotelsIcon } from "./webhotels.svg";
import { ReactComponent as EmailIcon } from "./email.svg";
import { ReactComponent as WebrtcIcon } from "./webrtc.svg";
import { ReactComponent as WordpressIcon } from "./wp.svg";
import { ReactComponent as SearchIcon } from "./searchIcon.svg"

/**
 * Return the icon component from enum.
 *
 * @param type
 */
export function getIconComponent ( type: SendanorIcon) : any {
    switch (type) {
        case SendanorIcon.ImagesIcon         : return WebrtcIcon;
        case SendanorIcon.PremiumDomainIcon  : return DomainsIcon;
        case SendanorIcon.InternetIcon       : return WebrtcIcon;
        case SendanorIcon.SupportIcon        : return WebrtcIcon;
        case SendanorIcon.ShoppingCartIcon   : return ShoppingCartIcon;
        case SendanorIcon.TrashIcon          : return TrashIcon;
        case SendanorIcon.SignInIcon         : return SignInIcon;
        case SendanorIcon.SignOutIcon        : return SignOutIcon;
        case SendanorIcon.MenuIcon           : return MenuIcon;
        case SendanorIcon.WebHotelsIcon      : return WebhotelsIcon;
        case SendanorIcon.VirtualServersIcon : return VirtualserversIcon;
        case SendanorIcon.DomainsIcon        : return DomainsIcon;
        case SendanorIcon.ShellsIcon         : return ShellsIcon;
        case SendanorIcon.DatabasesIcon      : return DatabasesIcon;
        case SendanorIcon.EmailIcon          : return EmailIcon;
        case SendanorIcon.WebrtcIcon         : return WebrtcIcon;
        case SendanorIcon.WordpressIcon      : return WordpressIcon;
        case SendanorIcon.SearchIcon         : return SearchIcon;
        case SendanorIcon.OutletIcon         : return WebrtcIcon;

        default : throw new TypeError(`Undefined icon type: ${type}`);
    }
}

export {
    WebrtcIcon as ImagesIcon,
    WebrtcIcon as OutletIcon,
    DomainsIcon as PremiumDomainIcon,
    WebrtcIcon as InternetIcon,
    WebrtcIcon as SupportIcon,
    ShoppingCartIcon,
    TrashIcon,
    SignInIcon,
    SignOutIcon,
    MenuIcon,
    WebhotelsIcon,
    VirtualserversIcon,
    DomainsIcon,
    ShellsIcon,
    DatabasesIcon,
    EmailIcon,
    WebrtcIcon,
    WordpressIcon,
    SearchIcon
};
